/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-unused-vars */

import LoggerBase from "./logger-base";

export default class NullLogger extends LoggerBase {
    logDebug(message: string): void {}

    logInfo(message: string): void {}

    logWarn(message: string): void {}

    logError(message: string | Error, error?: Error): void {}
}

export { NullLogger };
